import types from '../types';
import { getResetedCheckboxGroupState } from '.';

/**
 * @param {types.Filter[]} filters
 * @param {string} filterId
 * @returns {types.Filter[]}
 */
const setAccordionFiltersState = (filters, filterId) => filters.map(filter => {
    if (filter.id === filterId) {
        return {
            ...filter,
            radio: {
                ...filter.radio,
                checked: true
            }
        };
    }

    return {
        ...filter,
        options: getResetedCheckboxGroupState(filter.options),
        radio: {
            ...filter.radio,
            checked: false
        }
    };
});

export default setAccordionFiltersState;
